import { FC, useRef } from "react";
import { Fact, Result, extractTypedId } from "./types";

export function useFactInput(): {
  get(): Result<Fact, string>;
  FactInput: FC<JSX.IntrinsicElements["input"]>;
} {
  const ref = useRef<HTMLInputElement>(null);
  return {
    get() {
      if (!ref.current) {
        console.error("FactInput is not rendered");
        return {
          ok: false,
          error: "Encountered an unexpected internal error.",
        };
      }

      const matches = ref.current.value.match(/^(.+)\((.*)\)$/);
      if (!matches) {
        return {
          ok: false,
          error: "Fact must be of the form `<predicate>(<args>)`",
        };
      }
      // TODO: validate predicate is a valid symbol
      const predicate = matches[1].trim();
      const args = matches[2]
        .split(",")
        .map((arg) => arg.trim())
        .filter((arg) => arg !== "")
        .map(extractTypedId);
      return {
        ok: true,
        value: {
          predicate,
          args,
        },
      };
    },
    FactInput(props) {
      return <input ref={ref} {...props} />;
    },
  };
}
